var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2"},[_c('p',{staticClass:"pa-0 ma-0 text-body-2 font-weight-black"},[_vm._v(" "+_vm._s(_vm.cod)+" ")]),_c('p',{staticClass:"pa-0 ma-0"},[_vm._v(_vm._s(_vm._f("pascalCase")(_vm.description)))])])}
var staticRenderFns = []

export { render, staticRenderFns }